<template>
  <el-dialog
    title="职责内容"
    :visible.sync="urgencyPopShow"
    width="30%"
    :before-close="handleClose"
  >
    <div class="audios">
      <audio ref="notify" controls>
        <source src="baojinglingsheng.mp3">
      </audio>
    </div>
    <h4> {{ chooseData.DUTY_TITLE }} </h4>

    <el-select v-model="OptionValue" placeholder="请选择" @change="optionChange">
      <el-option
        v-for="item in optionX"
        :key="item.DUTY_ID"
        :label="item.DUTY_TITLE"
        :value="item.DUTY_ID"
      />
    </el-select>
    <div v-html="chooseData.DUTY_CONTENT" />

  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
// import { }
import { chooseDutysByDutyId, chooseDutys } from '@/api/alarm'

export default {
  data() {
    return {
      chooseData: {},
      optionX: [],
      id: '',
      OptionValue: ''
      // dialogVisible: false
    }
  },
  computed: {
    ...mapGetters(['urgencyShow', 'urgencyPopShow'])

  },
  created() {
    this.$nextTick(() => {
      this.init()
      this.chooseDutys()
      if (this.urgencyPopShow) {
        this.$refs.notify.play()
      }
    })
  },
  methods: {
    handleClose(done) {
      done()
      this.$store.commit('urgencyPop', false)
    },
    async init() {
      const response = await chooseDutysByDutyId(this.$store.getters.token, this.id)
      if (response.code === 200) {
        this.chooseData = response.data
      }
    },
    async chooseDutys() {
      const response = await chooseDutys(this.$store.getters.token, this.id)
      if (response.code === 200) {
        this.optionX = response.data
      }
    },
    optionChange(v) {
      this.id = v
      this.init()
    },
    playAlarm() {
      // 另外一种方式: 效果不好
      // let audio = new Audio()
      // audio.src = 'notify.mp3'
      // audio.play()
    }

  }
}
</script>

<style>
.audios{
  opacity: 0;
  position: absolute;
}

</style>
